import React from "react";

const StrainerContact = () => {
  return (
    <>
      <div className="info">
        <p>
          {" "}
          Filtro de Contactos.
          <br /> Con nuestro producto de Datos Filtrados de Contactos, usted
          suma todas las acciones SMS, IVR, Online, etc. y le da el Valor
          Agregado del Primer Contacto con el Cliente mediante nuestro
          Callcenter, permitiendo generar un filtro de las personas que
          realmente están interesadas en el producto.
        </p>
        <h4> Beneficios</h4>
        <ul>
          <li>Realiza varias Acciones al mismo tiempo.</li>
          <li>Baja Costos de Empleados y Estructura.</li>
          <li>Consigue el Contacto Realmente Efectivo para la Venta.</li>
          <li>Es el Servicio para un Modelo Creciente de Trabajo Actual.</li>
        </ul>
      </div>
    </>
  );
};

export default StrainerContact;
